import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-type-form',
  templateUrl: './doc-type-form.component.html',
  styleUrls: ['./doc-type-form.component.css']
})
export class DocTypeFormComponent implements OnInit {

  title="Add Document Type";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/contractor-doc-type/doc-type-form/doc-type-form.component.ts